module.exports = __webpack_public_path__ + "assets/img/trim_instructions.e5202a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/trim_instructions.png
// module id = 46
// module chunks = 4